import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Vote, FlaskConical, Lock, ChevronRight } from "lucide-react";
import { useElectionDay } from "@/context/ElectionDayContext";

const pad = (n) => String(n).padStart(2, "0");

const remaining = (iso) => {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  if (ms <= 0) return null;
  const s = Math.floor(ms / 1000);
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
};

export default function TallyBigButton() {
  const { ed } = useElectionDay();
  const navigate = useNavigate();
  const [t, setT] = useState(null);

  useEffect(() => {
    if (!ed?.tally_open_at) return;
    setT(remaining(ed.tally_open_at));
    const id = setInterval(() => setT(remaining(ed.tally_open_at)), 1000);
    return () => clearInterval(id);
  }, [ed?.tally_open_at]);

  if (!ed) return null;
  const open = !!ed.tally_open;
  const test = !!ed.tally_test;

  if (!open) {
    return (
      <div className="rounded-2xl border border-dashed border-border bg-muted/40 px-5 py-4 flex items-center gap-3"
        data-testid="tally-locked">
        <Lock className="h-5 w-5 text-muted-foreground shrink-0" />
        <div>
          <p className="font-display font-semibold text-base">Seçim Çetelesi kapalı</p>
          <p className="text-sm text-muted-foreground">
            {t ? `Açılışa ${t.d} gün ${pad(t.h)}:${pad(t.m)}:${pad(t.s)} kaldı` : "Açılış bekleniyor"}
            {" · "}{String(ed.tally_open_at || "").slice(0, 16).replace("T", " ")}
          </p>
        </div>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => navigate("/cetele")}
      data-testid="tally-big-button"
      className="group relative w-full overflow-hidden rounded-2xl px-6 py-7 sm:px-9 sm:py-9 text-left transition-transform active:scale-[0.99]"
      style={{
        background: test
          ? "linear-gradient(115deg,#1d2b53 0%,#3f2f6e 55%,#6d3b8e 100%)"
          : "linear-gradient(115deg,#7a1020 0%,#b3122b 50%,#e0373f 100%)",
        boxShadow: "0 18px 50px -18px rgba(10,10,30,0.7)",
      }}
    >
      <span className="pointer-events-none absolute -right-10 -top-16 h-60 w-60 rounded-full"
        style={{ background: "radial-gradient(closest-side, rgba(255,255,255,0.22), transparent)" }} />
      <div className="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl"
            style={{ background: "rgba(255,255,255,0.16)", border: "1px solid rgba(255,255,255,0.28)" }}>
            <Vote className="h-7 w-7 text-white" />
          </span>
          <div>
            {test && (
              <span className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-white mb-1.5"
                style={{ background: "rgba(255,255,255,0.2)" }} data-testid="tally-test-badge">
                <FlaskConical className="h-3.5 w-3.5" /> Test Modu
              </span>
            )}
            <h2 className="font-display text-2xl sm:text-4xl font-bold text-white leading-none">
              SEÇİM ÇETELESİ
            </h2>
            <p className="text-sm sm:text-base mt-1.5" style={{ color: "rgba(255,255,255,0.8)" }}>
              {test
                ? (ed.rehearsal_active
                  ? "ALIŞTIRMA PROVASI açık — girip işaretlemeyi deneyin, hata yapmaktan korkmayın"
                  : "Alıştırma modu — işaretlemeler 10 Ekim 22:00'de otomatik sıfırlanacak")
                : "Komite sandık ekranı ve Takip Merkezi açık"}
              {ed.marked_count ? ` · ${ed.marked_count} işaretleme` : ""}
            </p>
          </div>
        </div>
        <span className="inline-flex items-center gap-2 self-start rounded-full px-5 py-3 font-display font-bold text-white sm:self-auto"
          style={{ background: "rgba(255,255,255,0.18)", border: "1px solid rgba(255,255,255,0.3)" }}>
          Çeteleyi Aç <ChevronRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5" />
        </span>
      </div>
    </button>
  );
}
